import api from '@/api';

export default {
  async setBreadcrumbItems({ commit }, { breadcrumbItems }) {
    return commit('setBreadcrumbItems', { breadcrumbItems });
  },
  async setCollapse({ commit }, { isCollapse }) {
    commit('setCollapse', { isCollapse });
  },
  // 校准文件列表
  async fetchCaluploads({ commit }) {
    const res = await api.auth.getCalfiles();
    commit('setCaluploads', { caluploads: res.data.caluploads });
  },
  async deleteCalfile({ commit }, { filename }) {
    const res = await api.auth.deleteCalfile({ filename });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    commit('deleteCalfile', { filename });
  },
  // 删除预警
  async deleteWarning({ state }, { deviceId, warningIds }) {
    const res = await api.auth.deleteWarning({ deviceId, ids: warningIds });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    const device = state.device.devices.find(d => d.id === deviceId);
    const ids = new Set(warningIds);
    const warnings = device.Warnings.filter(w => !ids.has(w.id));
    device.Warnings = warnings;
  },
  async checkVersion({ commit }) {
    try {
      const res = await api.common.getVersion();
      commit('setVersion', res.version);
    } catch (err) {
      console.error('checkVersion', err);
      commit('setVersion', 'v1.0');
    }
  },
};

